var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingcart = function SvgShoppingcart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.075a.4.4 0 1 0 0 .8h1.45l2.124 7.318a.6.6 0 0 0 .576.432h7.6a.4.4 0 0 0 0-.8H7.3l-.203-.7h8.01a.6.6 0 0 0 .567-.402l1.61-4.6a.6.6 0 0 0-.566-.798H5.413l-.237-.817a.6.6 0 0 0-.577-.433H3Zm2.645 2.05 1.22 4.2h8.1l1.47-4.2H5.646ZM8.75 14.95a.45.45 0 1 0 0-.9.45.45 0 0 0 0 .9Zm0 .8a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4.7-1.25a.45.45 0 1 1-.9 0 .45.45 0 0 1 .9 0Zm.8 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z",
    fill: "currentColor"
  })));
};
export default SvgShoppingcart;